import { render, staticRenderFns } from "./PlayerDrawer.vue?vue&type=template&id=367e86ac&scoped=true"
import script from "./PlayerDrawer.vue?vue&type=script&lang=js"
export * from "./PlayerDrawer.vue?vue&type=script&lang=js"
import style0 from "./PlayerDrawer.vue?vue&type=style&index=0&id=367e86ac&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367e86ac",
  null
  
)

export default component.exports